import { render, staticRenderFns } from "./TabComment.vue?vue&type=template&id=383bd973&scoped=true&"
import script from "./TabComment.vue?vue&type=script&lang=js&"
export * from "./TabComment.vue?vue&type=script&lang=js&"
import style0 from "./TabComment.vue?vue&type=style&index=0&id=383bd973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383bd973",
  null
  
)

export default component.exports